import { z } from "zod";

export type CreatePaymentResponseModel = z.infer<typeof CreatePaymentResponseModelSchema>;
export const CreatePaymentResponseModelSchema = z.object({
    paymentId: z.string(),
    hostedPaymentPageUrl: z.string(),
});

export const InvoiceSchema = z.object({
    invoiceNumber: z.string(),
});

export type ChargePaymentResponseModel = z.infer<typeof ChargePaymentResponseModelSchema>;
export const ChargePaymentResponseModelSchema = z.object({
    chargeId: z.string(),
    invoice: InvoiceSchema,
});

export type RefundChargeResponseModel = z.infer<typeof RefundChargeResponseModelSchema>;
export const RefundChargeResponseModelSchema = z.object({
    refundId: z.string(),
});

export type CreatePaymentResponseDto = z.infer<typeof CreatePaymentResponseDtoSchema>;
export const CreatePaymentResponseDtoSchema = z.object({
    errorMessage: z.string().optional().nullable(),
    paymentId: z.string().optional().nullable(),
});

